module.exports = __webpack_public_path__ + "static/media/Region_Marching_Adjudication_Sheets.9b7d0906.pdf";


//////////////////
// WEBPACK FOOTER
// ./src/files/24-25/Region_Marching_Adjudication_Sheets.pdf
// module id = 226
// module chunks = 0